import React, { useState, useContext, createContext, useEffect } from "react";

import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';

export interface AuthInterface {
    jwtToken?: string,
    signin: (cb: (currentStatus: string, data?:Object) => void, user: string, pass: string) => void,
    confirmMfa: (cb: (currentStatus: string, data?:Object) => void,  mfaCode: string, session:any) => void,
    changePassword: (cb: (currentStatus: string, data?:Object) => void, name: string, pass: string) => void,
    refresh: (cb: () => void) => void
    signout: (cb: () => void) => void
}

function ProvideAuthInterface() {
    let [user, setUser] = useState<string | undefined>(undefined);
    let [jwtToken, setJwtToken] = useState<string | undefined>(undefined);
    let [cognitoSession, setCognitoSession] = useState<AmazonCognitoIdentity.CognitoUserSession | null>(null);

    const API_ROOT = window.app && window.app.env.API_URL;
    //REACT Dev credential
    const poolData = {
        UserPoolId: API_ROOT.UserPoolId, //'us-east-1_zJLFl2fz6',
        ClientId: API_ROOT.ClientId //'7f2h4hlcb3n4k8q7c8mhejqvam'
    };

    let cognitoUser:AmazonCognitoIdentity.CognitoUser;



    const signin = (callback: (currentStatus: string, data?:Object) => void, user: string, pass: string) => {
        const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
        const userData = {
            Username: user,
            Pool: userPool,
        };
        cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

        const authenticationData = {
            Username: user,
            Password: pass,
        };
        const authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
            authenticationData
        );

        setUser(user);
		console.log(authenticationData)
        if(cognitoUser !== undefined){

            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: (result: any) => {
                    var accessToken = result.getAccessToken().getJwtToken();
                    const token = cognitoUser!.getSignInUserSession()!.getIdToken()!.getJwtToken();
                    setJwtToken(token);
                    setCognitoSession(cognitoUser!.getSignInUserSession())
                    console.log(token)

                    window.sessionStorage.setItem('user', user);
                    window.sessionStorage.setItem('token', token);

                    callback('AUTHENTICATED');
                },

                onFailure: function (err: any) {
    				console.log('In the err' + err);

                    callback('ERROR',{err:err});
                },

                mfaRequired: (challengeName: string, challengeParameters: object) => {
                    // This is where MFA is detected. We resolve with the cognitoUser
                    // so the calling component can then call confirmMfa.
                    console.log('MFA required:', challengeName, challengeParameters);
                    const this_session = (cognitoUser as any).Session;
                    callback('MFA_REQUIRED',{name:challengeName,parameters:challengeParameters,session:this_session});
                },
                selectMFAType: (challengeName: string, challengeParameters: object) => {
                    setCognitoSession((cognitoUser as any).Session);
                    //MFAS_CAN_CHOOSE: "["EMAIL_OTP","SMS_MFA"]"
                    console.log('selectMFAType called. Challenge Name:', challengeName, 'Parameters:', challengeParameters);
                    // In a real application, you might present a UI to the user
                    // to choose their preferred MFA method if multiple are enabled.
                    // For simplicity, we'll try to select SMS_MFA if available.
                    if (challengeParameters && (challengeParameters as any).MFAS_CAN_CHOOSE && (challengeParameters as any).MFAS_CAN_CHOOSE.includes('SMS_MFA')) {
                        console.log('Selecting SMS_MFA...');
                        //callback('MFA_REQUIRED',{name:challengeName,parameters:challengeParameters});
                        //sendMfaSelectionAnswer(callback,'SMS_MFA')
                        sendMfaSelectionAnswer(callback,'SMS_MFA')

                    } else if (challengeParameters && (challengeParameters as any).MFAS_CAN_CHOOSE && (challengeParameters as any).MFAS_CAN_CHOOSE.includes('TOTP_MFA')) {
                        console.log('Selecting TOTP_MFA...');
                        //cognitoUser.sendMFASelection('TOTP_MFA', this); // 'this' refers to the callbacks object
                    } else {
                        console.error('No supported MFA type found to select automatically. Available types:', (challengeParameters as any)?.MFATypes);
                        //setGlobalError('Multiple MFA types available, but none supported for automatic selection. Please configure your MFA settings.');
                        //reject(new Error('MFA type selection required.'));
                    }
                },

                newPasswordRequired: function (userAttributes: any, requiredAttributes: any) {
                    console.log("New pass");
                    setCognitoSession((cognitoUser as any).Session);
                    callback('NEWPASS');
                },



            });
        }
    }

    const sendMfaSelectionAnswer = (callback: (currentStatus: string, data?:Object) => void, answerChallenge: string) => {
        if(cognitoUser !== undefined)
        cognitoUser.sendMFASelectionAnswer(answerChallenge,{
                onSuccess: function(session: AmazonCognitoIdentity.CognitoUserSession) {
                    console.log('success')
                },
                onFailure: function(err: any) {
                    console.log('In the err' + err);
                },
                mfaRequired: (challengeName: string, challengeParameters: object) => {
                    // This is where MFA is detected. We resolve with the cognitoUser
                    // so the calling component can then call confirmMfa.
                    console.log('MFA required:', challengeName, challengeParameters);
                    const this_session = (cognitoUser as any).Session;
                    callback('MFA_REQUIRED',{name:challengeName,parameters:challengeParameters,session:this_session});
                },
            }); // 'this' refers to the callbacks object
    }

    const confirmMfa = (callback: (currentStatus: string, data?:Object) => void, mfaCode: string, sessionIn:any) => {
        if(!sessionIn)
            return

        const session = sessionIn as AmazonCognitoIdentity.CognitoUser;
        if (!user) return;

        const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
        const userData = {
            Username: user,
            Pool: userPool,
        };

        const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
        if (session)
            (cognitoUser as any).Session = session;
        //setGlobalError(null);
        //return new Promise((resolve, reject) => {
        if(cognitoUser !== undefined)
            cognitoUser.sendMFACode(mfaCode, {
                onSuccess: (session: AmazonCognitoIdentity.CognitoUserSession) => {
                    console.log('MFA confirmation successful.');
                    callback('AUTHENTICATED',{session:session})
                    //processSession(session, cognitoUser); // Process the session
                    //resolve();
                },
                onFailure: (err: any) => {
                    console.error('MFA confirmation failure:', err);
                    callback('ERROR',{err:err})
                    //setGlobalError(err.message || 'MFA confirmation failed.');
                    //reject(err);
                }
            });
        //});
    };

    const refresh = (callback: () => void) => {
        if (cognitoSession === null || !user)
            return;

        const refresh = cognitoSession.getRefreshToken();

        const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
        const userData = {
            Username: user,
            Pool: userPool,
        };

        cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
        cognitoUser.setSignInUserSession(cognitoSession);

        cognitoUser.refreshSession(refresh, (err, session) => {
            if (err) {//throw err;
                console.log('In the err' + err);
                callback()
            }
            else {
                console.log('session ' + session);
                const token = session!.getIdToken()!.getJwtToken();
                setJwtToken(token);
                setCognitoSession(session)

                //window.sessionStorage.setItem('user', user!);
                window.sessionStorage.setItem('token', token);

                callback()
            }
        });
    }

    const changePassword = (callback: (currentStatus: string, data?:Object) => void, name: string, newpass: string) => {
        if (!user) return;

        const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
        const userData = {
            Username: user,
            Pool: userPool,
        };

        const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
        if (cognitoSession)
            (cognitoUser as any).Session = cognitoSession;

        //cognitoUser.completeNewPasswordChallenge(newpass, { name: '', email: '' }, {
        cognitoUser.completeNewPasswordChallenge(newpass, {}, {
            onSuccess: (result: any) => {
                var accessToken = result.getAccessToken().getJwtToken();
                const token = cognitoUser.getSignInUserSession()!.getIdToken()!.getJwtToken();
                setJwtToken(token);
                console.log(token)
                callback('AUTHENTICATED');
            },

            onFailure: function (err: any) {
                console.log('Failed completeNewPasswordChallenge:'+err);
                callback('ERROR',{err:err});
            },

            mfaRequired: (challengeName: string, challengeParameters: object) => {
                // This is where MFA is detected.
                console.log('MFA required:', challengeName, challengeParameters);
                const this_session = (cognitoUser as any).Session;
                callback('MFA_REQUIRED',{name:challengeName,parameters:challengeParameters,session:this_session});
            },
            selectMFAType: (challengeName: string, challengeParameters: object) => {
                setCognitoSession((cognitoUser as any).Session);
                //MFAS_CAN_CHOOSE: "["EMAIL_OTP","SMS_MFA"]"
                console.log('selectMFAType called. Challenge Name:', challengeName, 'Parameters:', challengeParameters);
                // In a real application, you might present a UI to the user
                // to choose their preferred MFA method if multiple are enabled.
                // For simplicity, we'll try to select SMS_MFA if available.
                if (challengeParameters && (challengeParameters as any).MFAS_CAN_CHOOSE && (challengeParameters as any).MFAS_CAN_CHOOSE.includes('SMS_MFA')) {
                    console.log('Selecting SMS_MFA...');
                    //callback('MFA_REQUIRED',{name:challengeName,parameters:challengeParameters});
                    //sendMfaSelectionAnswer(callback,'SMS_MFA')
                    sendMfaSelectionAnswer(callback,'SMS_MFA')

                //} else if (challengeParameters && (challengeParameters as any).MFAS_CAN_CHOOSE && (challengeParameters as any).MFAS_CAN_CHOOSE.includes('TOTP_MFA')) {
                //    console.log('Selecting TOTP_MFA...');
                    //cognitoUser.sendMFASelection('TOTP_MFA', this); // 'this' refers to the callbacks object
                } else {
                    console.error('No supported MFA type found to select automatically. Available types:', (challengeParameters as any)?.MFATypes);
                    //setGlobalError('Multiple MFA types available, but none supported for automatic selection. Please configure your MFA settings.');
                }
            },
        })
    }

    const signout = (callback: () => void) => {
        setJwtToken(undefined);
        callback();
    }

    return {
        jwtToken,
        signin,
        confirmMfa,
        changePassword,
        refresh,
        signout
    }
};

export const AuthContext = createContext<AuthInterface | null>(null);

export function ProvideAuth({ children }: any) {
    const auth = ProvideAuthInterface();
    return (
        <AuthContext.Provider value={auth}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
